/* eslint-disable */
/* istanbul ignore file */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface exportAssetProvisioningDetailsState {
  isLoading: boolean
  loadingError: string | null
  exportAssetProvisioningDetails: any
}

// Initial state of the slice
const initialState: exportAssetProvisioningDetailsState = {
  isLoading: true,
  loadingError: null,
  exportAssetProvisioningDetails: null
}

// Slice to return from action
export const exportAssetProvisioningDetailsSlice = createSlice({
  name: 'exportAssetProvisioningDetails',
  initialState,
  reducers: {
    exportAssetProvisioningDetailsLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        exportAssetProvisioningDetails: []
      }
    },
    exportAssetProvisioningDetailsUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        exportAssetProvisioningDetails: action.payload
      }
    },
    exportAssetProvisioningDetailsErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        exportAssetProvisioningDetails: null
      }
    }
  }
})

// Actions to export
export const {
  exportAssetProvisioningDetailsLoadingAction,
  exportAssetProvisioningDetailsUpdateAction,
  exportAssetProvisioningDetailsErrorAction
} = exportAssetProvisioningDetailsSlice.actions

export default exportAssetProvisioningDetailsSlice.reducer
